module.exports = __webpack_public_path__ + "static/img/image_2.18bac5cf.png";